<template>
    <div id="calendar" class="mb-5 container page">
        <h2>Planning</h2>
        <planning></planning>
    </div>
</template>

<script>
import Planning from '@/components/Planning';

export default {
    components: {
        Planning
    },
}
</script>

<style scoped>
</style>